<template>
    <v-app>
        <views/>
    </v-app>
</template>

<script>

import Views from "./Views.vue" 

export default {
    components: {Views},
    data () {
        return {
        }
    },
    

}
</script>
